import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Table, Spin, Button, Modal, Tooltip } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import ColorCreationForm from "../../Forms/ColorCreationForm/ColorCreationForm";

const ColorTable = ({
  history,
  loading,
  data,
  userData,
  callReFetch,
  dispatch,
  handleDelete,
  pagination,
  onChange,
  sortField,
  sortOrder,
}) => {
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [selectedColor, setSelectedColor] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleOpenEditModal = (id) => {
    const colorToEdit = data.find((color) => color._id === id);
    if (colorToEdit) {
      setSelectedColor(colorToEdit);
      setIsEditModalVisible(true);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalVisible(false);
    setSelectedColor(null);
  };

  const isAdmin =
    userData?.roles?.includes("admin");
  const renderActionButton = (id) => {
    if (!isAdmin) return null;
    return (
      <>
        {isMobileView ? (
          <>
            <Tooltip title="Edit">
              <Button
                icon={<EditOutlined />}
                onClick={() => handleOpenEditModal(id)}
                size="small"
                shape="circle"
                style={{ marginRight: 8 }}
              />
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                icon={<DeleteOutlined />}
                onClick={() => handleDelete(id)}
                size="small"
                shape="circle"
                danger
              />
            </Tooltip>
          </>
        ) : (
          <>
            <Button
              onClick={() => handleOpenEditModal(id)}
              style={{ marginRight: 8 }}
            >
              Edit
            </Button>
            <Button onClick={() => handleDelete(id)} danger>
              Delete
            </Button>
          </>
        )}
      </>
    );
  };

  const handleTableOnChange = (pagination, filteredInfo, sorter) => {
    if (onChange) {
      onChange(pagination, filteredInfo, sorter);
    } else {
      // Fallback for backward compatibility
      dispatch({ type: "sorter", payload: sorter });
      dispatch({ type: "filteredInfo", payload: filteredInfo });
      callReFetch();
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: true,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      sorter: true,
      defaultSortOrder: sortField === 'code' ? sortOrder : null,
    },
    {
      title: "Action",
      render: (item) => renderActionButton(item._id),
      width: 200,
    },
  ];

  return (
    <>
      <div style={{ width: "50vw" }}>
        <Spin spinning={loading}>
          {data && (
            <Table
              columns={columns}
              dataSource={data}
              onChange={handleTableOnChange}
              rowKey="_id"
              pagination={pagination || false}
            />
          )}
        </Spin>
        <Modal
          title="Edit Color"
          open={isEditModalVisible}
          footer={null}
          onCancel={handleCloseEditModal}
        >
          <ColorCreationForm
            history={history}
            isEditMode
            callReFetch={callReFetch}
            data={selectedColor}
            onClose={handleCloseEditModal}
          />
        </Modal>
      </div>
    </>
  );
};

ColorTable.propTypes = {
  history: PropTypes.object,
  loading: PropTypes.bool,
  data: PropTypes.array,
  userData: PropTypes.object,
  callReFetch: PropTypes.func,
  dispatch: PropTypes.func,
  handleDelete: PropTypes.func,
  pagination: PropTypes.object,
  onChange: PropTypes.func,
  sortField: PropTypes.string,
  sortOrder: PropTypes.string,
};

export default ColorTable;
